// src/router.js (hash yerine pathname kullanan sürüm)
export const routes = [
  "/",
  "/about",          // eklendi
  "/policies",       // eklendi
  "/services", "/services/:key",
  "/projects",
  "/fleet", "/fleet/:id",
  "/gallery", "/catalog", "/contact", "/404"
];

function patternToRegex(pattern) {
  const keys = [];
  const rx = pattern
    .replace(/\//g, "\\/")
    .replace(/:([A-Za-z0-9_]+)/g, (_, k) => { keys.push(k); return "([^\\/]+)"; });
  return { regex: new RegExp(`^${rx}$`), keys };
}

const compiled = routes.map((p) => ({ pattern: p, ...patternToRegex(p) }));

export function parseLocation() {
  const path = window.location.pathname || "/";
  for (const r of compiled) {
    const m = path.match(r.regex);
    if (m) {
      const params = {};
      r.keys.forEach((k, i) => params[k] = decodeURIComponent(m[i + 1]));
      return { path: r.pattern, params, actual: path };
    }
  }
  return { path: "/404", params: {}, actual: path };
}

export function navigate(to) {
  window.history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function listenLocationChange(setter) {
  const handler = () => setter(parseLocation());
  window.addEventListener("popstate", handler);
  return () => window.removeEventListener("popstate", handler);
}